import { DrawingCardSkeleton } from "@/components/DrawingCardSkeleton";

interface LoadingDrawingsGridProps {
  count: number;
}

export function LoadingDrawingsGrid({ count }: LoadingDrawingsGridProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      {Array.from({ length: count }).map((_, index) => (
        <DrawingCardSkeleton key={index} />
      ))}
    </div>
  );
}